import { FC, useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getRegistrationStatus } from '../../../validation/registration';

import { FormButton } from 'thermia-react-container';
import { RegistrationsContext } from '../../../context/contextProvider';
import CompleteRegistrationDialog from './completeRegistrationDialog/completeRegistrationDialog';
import {useRefreshData} from "../hooks/useRefreshData";

type Props = {
  formIsDirty: boolean;
};

const CompleteRegistrationButton: FC<Props> = ({ formIsDirty }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation('registrations');
  const { registrations } = useContext(RegistrationsContext);
  const { activeRegistration } = registrations;
  const refreshData = useRefreshData();
  const {canBeCompleted} = useMemo(() => getRegistrationStatus(activeRegistration ?? { id: 'no-active', partnerId: 'no-active' }), [activeRegistration]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    refreshData();
    setOpen(false);
  }

  return (
    <>
      <FormButton
        color="success"
        disabled={!canBeCompleted || formIsDirty}
        variant="contained"
        title={t('registrations.general.completeRegistration')}
        onClick={handleOpen}
      />
      <CompleteRegistrationDialog open={open} onClose={handleClose} />
    </>
  );
};

export default CompleteRegistrationButton;
